module.exports = __webpack_public_path__ + "img/about_1.4117f0c2.jpg";